import { decodeJWT, removeCookies, setCookies } from "../../../utils";
import { userRoleItems } from "../../../utils/enum";
import { clearSocketActions } from "../socketActions/socketActions";

export const setUserAction = (accessToken) => {
  return async (dispatch) => {
    setCookies("accessToken", accessToken);

    const decodedToken = decodeJWT(accessToken);
    const role = decodedToken?.role;

    await dispatch({
      type: "SET_USER",
      payload: {
        accessToken,
        isAdmin: role === userRoleItems[0],
        isWaiter: role === userRoleItems[1],
        role,
        phoneNumber: decodedToken?.phoneNumber,
      },
    });
  };
};

export const clearUserAction = () => {
  return async (dispatch) => {
    removeCookies("accessToken");

    localStorage.clear();
    sessionStorage.clear();

    window.location.href = "/auth/login";

    await dispatch(clearSocketActions());
    await dispatch({ type: "CLEAR_USER" });
  };
};
